'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ProjectTypeServiceCtrl
 * @description
 * # ProjectTypeCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.services')
  .factory('ProjectTypeCatalog', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_PROJECT_URL = domain.name + '/api/v1/project_types/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_PROJECT_URL,
      baseModelName: 'project_type'
    });

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    return baseService;
  }]);
